import React from 'react';
import PropTypes from 'prop-types';

class SearchBar extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            name: this.props.exvalue
        }
        this.textChange = this.textChange.bind(this)
    }
    textChange (event) {
        this.setState({
            name: event.target.value
        })
        this.props.listData(event.target.value)
    }
    // eslint-disable-next-line react/no-deprecated

    componentDidUpdate (prevProps) {
        if (prevProps.exvalue !== this.props.exvalue) {
            this.textChange = this.textChange.bind(this)
            this.setState({ name: this.props.exvalue })
        }
    }
    render () {
        return (
          <div>
            <input
              className='inputHeader'
              value={this.state.name}
              onChange={this.textChange}
              placeholder="Title"
              autoFocus="autoFocus"
              fullwidth="true"/>
          </div>
        )
    }
}

SearchBar.propTypes = {
    exvalue: PropTypes.string,
    listData: PropTypes.func
}
export default SearchBar
